var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VRow',{attrs:{"column":""}},[((_vm.$isUserAdmin || _vm.$isUserMentor) && _vm.$route.name == 'worksheet.index' && _vm.isEnabledFeature('worksheets'))?_c('WorksheetsAdmin'):(_vm.$isUserAdmin || _vm.$isUserMentor)?_c('LessonsAdmin'):_c('LessonsNormal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }